import React, { useEffect, useState, useCallback } from 'react';
import Sidebar from '../../components/Sidebar';
import './internos.css';
import { Link } from 'react-router-dom';
// Botão "Cadastrar interno" (RegisterInternals) desativado — substituído pela Entrada Unificada.
// Comentado (não excluído) para permitir rollback rápido caso surja algum caso não coberto ainda.
// import RegisterInternals from '../Internos/registerInternal';
import UnifiedEntry from './unifiedEntry';
import { useInternals } from '../../context/internalContext';
import { useUnits } from '../../context/unitsContext';
import { useUsers } from '../../context/usersContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import ReactPaginate from 'react-paginate';
import VisibleAccess from '../../permissions/VisibleAccess';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import Modal from '../../components/modal';
import ConfirmModal from '../../components/modal/confirmModal';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import X from '../../assets/icons/x.svg';
import Skeleton from '../../components/Skeleton';
import InternalsFilterPanel, { EMPTY_INTERNALS_FILTERS } from '../../components/InternalsFilterPanel';
import { obterStatusVisualInterno } from '../../utils/internalStatus';
import { toast } from 'react-toastify';
import useSubmitLock from '../../utils/useSubmitLock';
import ActionIconButton from '../../components/ActionIconButton';
import { FaEye, FaRunning } from 'react-icons/fa';

const normalizeStatusText = (value = '') => (
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toUpperCase()
);

const getStatusName = (status) => (
  typeof status === 'string'
    ? status
    : (status?.name || '')
);

const ALL_STATUS_OPTION = { value: '', label: 'Todos os status' };

const obterStatusVisualPorInterno = (internal) => (
  obterStatusVisualInterno({
    siglaUnidadeInterno: internal?.unit_acronym,
    statusBackend: internal?.status,
  })
);

const isTemporaryLeavingStatus = (internal) => {
  const backendStatus = normalizeStatusText(getStatusName(internal?.status));
  const visualStatus = normalizeStatusText(obterStatusVisualPorInterno(internal));
  return backendStatus === 'SAIDA TEMPORARIA' || visualStatus === 'SAIDA TEMPORARIA';
};

const getCellPavilionId = (cell) => Number(
  cell?.pavilion?.id ?? cell?.pavilion_id ?? cell?.pavilion
);

const resolveCellUnitId = (cell) => (
  cell?.pavilion?.unit?.id
  ?? cell?.pavilion?.unit_id
  ?? cell?.pavilion?.unit
  ?? cell?.unit?.id
  ?? cell?.unit_id
  ?? cell?.unit
  ?? null
);

const toValidNumber = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

const isTrueLike = (value) => (
  value === true || String(value).toLowerCase() === 'true' || value === 1 || String(value) === '1'
);

function InternalsByUnit() {
  const { listInternals, getLastPendingTemporaryLeavingRecord, createLeavingRecord, listTypeLeaving } = useInternals();
  const { getCellById } = useUnits();
  const { effectiveUnitId, buildUnitReadParams, userUnits, requireWriteUnit } = useUsers();
  const { listInternalStatus } = useAuxiliaries();
  const [internals, setInternals] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // const [showRegisterInternal, setShowRegisterInternal] = useState(false);
  // const [isRegisterLocked, setIsRegisterLocked] = useState(false);
  const [showUnifiedEntry, setShowUnifiedEntry] = useState(false);
  const [isUnifiedEntryLocked, setIsUnifiedEntryLocked] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState(EMPTY_INTERNALS_FILTERS);
  const [statusOptions, setStatusOptions] = useState([ALL_STATUS_OPTION]);
  const [isLoadingInternals, setIsLoadingInternals] = useState(true);
  const [temporaryReturnAccessByInternal, setTemporaryReturnAccessByInternal] = useState({});

  const [showFugaModal, setShowFugaModal] = useState(false);
  const [fugaInternal, setFugaInternal] = useState(null);
  const [fugaLeavingDate, setFugaLeavingDate] = useState('');
  const [fugaTypeLeavingId, setFugaTypeLeavingId] = useState(null);
  const [showFugaConfirmModal, setShowFugaConfirmModal] = useState(false);
  const {
    isSubmitting: isSubmittingFuga,
    runWithSubmitLock: runFugaSubmit,
  } = useSubmitLock();

  const unidadeAtiva = (
    Array.isArray(userUnits)
      ? userUnits.find((unit) => String(unit?.id) === String(effectiveUnitId))
      : null
  ) || (Array.isArray(userUnits) && userUnits.length === 1 ? userUnits[0] : null);

  const fetchInternals = useCallback(async () => {
    setIsLoadingInternals(true);
    try {
      const offset = currentPage * itemsPerPage;

      const params = {
        limit: itemsPerPage,
        offset,
        ...(appliedFilters.name ? { name: appliedFilters.name } : {}),
        ...(appliedFilters.cpf ? { cpf: appliedFilters.cpf.replace(/\D/g, '') } : {}),
        ...(appliedFilters.mother ? { mother: appliedFilters.mother } : {}),
        ...(appliedFilters.aka ? { aka: appliedFilters.aka } : {}),
        ...(appliedFilters.status ? { status: appliedFilters.status } : {}),
        // A cela já implica o pavilhão no backend: se uma cela foi filtrada, o pavilhão não é enviado junto.
        ...(appliedFilters.cell
          ? { cell: appliedFilters.cell }
          : (appliedFilters.pavilion ? { pavilion: appliedFilters.pavilion } : {})),
      };

      const response = await listInternals(buildUnitReadParams(params));
      if (response) {
        let normalizedInternals = Array.isArray(response.results) ? response.results : [];

        if (appliedFilters.status) {
          const normalizedSelectedStatus = normalizeStatusText(appliedFilters.status);
          normalizedInternals = normalizedInternals.filter((internal) => {
            const backendStatusName = getStatusName(internal?.status);
            const visualStatusName = obterStatusVisualPorInterno(internal);
            return (
              normalizeStatusText(backendStatusName) === normalizedSelectedStatus
              || normalizeStatusText(visualStatusName) === normalizedSelectedStatus
            );
          });
        }

        setInternals(normalizedInternals);
        setTotalItems(typeof response.count === 'number' ? response.count : normalizedInternals.length);
      }
    } catch (error) {
      console.error('Erro ao buscar internos:', error);
      setInternals([]);
      setTotalItems(0);
    } finally {
      setIsLoadingInternals(false);
    }
  }, [listInternals, buildUnitReadParams, itemsPerPage, currentPage, appliedFilters]);

  useEffect(() => {
    fetchInternals();
  }, [fetchInternals]);

  useEffect(() => {
    const fetchStatusOptions = async () => {
      const response = await listInternalStatus();
      const results = Array.isArray(response?.results) ? response.results : [];
      setStatusOptions([
        ALL_STATUS_OPTION,
        ...results.map((status) => ({ value: status.name, label: status.name })),
      ]);
    };
    fetchStatusOptions();
  }, [listInternalStatus]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  // const toggleRegisterInternal = () => {
  //   if (isRegisterLocked) return;
  //   setShowRegisterInternal(!showRegisterInternal);
  // };

  // const handleInternalSave = async () => {
  //   setShowRegisterInternal(false);
  //   setIsRegisterLocked(false);
  //   await fetchInternals();
  // };

  const toggleUnifiedEntry = () => {
    if (isUnifiedEntryLocked) return;
    setShowUnifiedEntry(!showUnifiedEntry);
  };

  const handleUnifiedEntrySave = async () => {
    setShowUnifiedEntry(false);
    setIsUnifiedEntryLocked(false);
    await fetchInternals();
  };

  const handleFiltersSearch = (filters) => {
    setAppliedFilters(filters);
    setCurrentPage(0);
  };

  const handleFiltersClear = () => {
    setAppliedFilters(EMPTY_INTERNALS_FILTERS);
    setCurrentPage(0);
  };

  const getStatusColor = (status) => {
    if (status === 'Preso') return 'red-text';
    if (status === 'Fugitivo') return 'orange-text';
    if (status === 'Liberado') return 'green-text';
    if (status === 'Monitorado') return 'blue-text';
    if (status === 'Saída Temporária' || status === 'Saida Temporaria') return 'purple-text';
    return '';
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  // Resolve se a unidade ativa do usuário é a mesma unidade de origem da saída temporária —
  // necessário pra decidir se a ação de "Fuga na Saída Temporária" pode aparecer pra esse interno.
  const resolveTemporaryReturnAccessForInternal = useCallback(async (internal, selectedUnitId) => {
    if (!internal?.id || !selectedUnitId || !isTemporaryLeavingStatus(internal)) {
      return { allowed: false, originUnitId: null, originCellId: null, originPavilionId: null };
    }

    try {
      const activeRecord = await getLastPendingTemporaryLeavingRecord(internal.id);
      if (!activeRecord || !isTrueLike(activeRecord?.active)) {
        return { allowed: false, originUnitId: null, originCellId: null, originPavilionId: null };
      }

      const originCellId = toValidNumber(activeRecord?.origin_cell);
      if (!originCellId) {
        return { allowed: false, originUnitId: null, originCellId: null, originPavilionId: null };
      }

      const originCell = await getCellById(originCellId, { silent: true });
      const originUnitId = resolveCellUnitId(originCell);
      const originPavilionId = toValidNumber(getCellPavilionId(originCell));

      if (originUnitId === null || originUnitId === undefined) {
        return { allowed: false, originUnitId: null, originCellId: null, originPavilionId: null };
      }

      const allowed = String(originUnitId) === String(selectedUnitId);
      return { allowed, originUnitId, originCellId, originPavilionId };
    } catch (error) {
      return { allowed: false, originUnitId: null, originCellId: null, originPavilionId: null };
    }
  }, [getLastPendingTemporaryLeavingRecord, getCellById]);

  useEffect(() => {
    let isMounted = true;

    const loadTemporaryReturnAccess = async () => {
      const writeUnit = requireWriteUnit();
      const temporaryInternals = Array.isArray(internals)
        ? internals.filter((internal) => isTemporaryLeavingStatus(internal))
        : [];

      if (!writeUnit.ok || !temporaryInternals.length) {
        if (isMounted) setTemporaryReturnAccessByInternal({});
        return;
      }

      const entries = await Promise.all(
        temporaryInternals.map(async (internal) => {
          const access = await resolveTemporaryReturnAccessForInternal(internal, writeUnit.unitId);
          return [internal.id, access];
        })
      );

      if (!isMounted) return;

      const nextAccessMap = {};
      entries.forEach(([internalId, access]) => {
        nextAccessMap[internalId] = access;
      });
      setTemporaryReturnAccessByInternal(nextAccessMap);
    };

    loadTemporaryReturnAccess();

    return () => { isMounted = false; };
  }, [internals, effectiveUnitId, requireWriteUnit, resolveTemporaryReturnAccessForInternal]);

  const canShowFugaAction = (internal) => (
    isTemporaryLeavingStatus(internal) && Boolean(temporaryReturnAccessByInternal?.[internal?.id]?.allowed)
  );

  const closeFugaModal = () => {
    setShowFugaModal(false);
    setFugaInternal(null);
    setFugaLeavingDate('');
    setFugaTypeLeavingId(null);
  };

  const handleOpenFugaModal = async (internal) => {
    const writeUnit = requireWriteUnit();
    if (!writeUnit.ok) { toast.warning(writeUnit.message); return; }

    try {
      const types = await listTypeLeaving();
      const typesArr = Array.isArray(types) ? types : (types?.results || []);
      const fugaType = typesArr.find((t) =>
        String(t.name || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim() === 'fuga'
      );
      if (!fugaType) {
        toast.error('Tipo de saída "Fuga" não encontrado.');
        return;
      }
      setFugaTypeLeavingId(fugaType.id);
    } catch {
      toast.error('Erro ao carregar tipos de saída.');
      return;
    }

    setFugaInternal(internal);
    setFugaLeavingDate('');
    setShowFugaModal(true);
  };

  const handleFugaSubmit = (event) => {
    event.preventDefault();
    if (!fugaLeavingDate) { toast.warning('Informe a data da fuga.'); return; }
    setShowFugaConfirmModal(true);
  };

  const handleFugaConfirm = async () => {
    await runFugaSubmit(async () => {
      const data = new FormData();
      data.append('internal', fugaInternal.id);
      data.append('type_leaving', fugaTypeLeavingId);
      data.append('leaving_date', fugaLeavingDate);

      try {
        await createLeavingRecord(data);
        toast.success('Fuga registrada com sucesso.');
        setShowFugaConfirmModal(false);
        closeFugaModal();
        await fetchInternals();
      } catch (error) {
        const apiMessage = error?.response?.data?.message || error?.response?.data?.detail;
        toast.error(
          typeof apiMessage === 'string' && apiMessage
            ? apiMessage
            : 'Erro ao registrar fuga.'
        );
      }
    });
  };

  const renderizarLinhaInterno = (internal) => {
    const visualStatus = obterStatusVisualPorInterno(internal);

    return (
      <tr key={internal.id}>
        <td>{internal.name}</td>
        <td>{internal.cpf ? internal.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '-'}</td>
        <td>{internal.unit_acronym}</td>
        <td>{internal.pavilion_name}</td>
        <td>{internal.cell_name}</td>
        <td>
          <span className={getStatusColor(visualStatus)}>{visualStatus || '-'}</span>
        </td>
        <td className="td-table-actions">
          <ActionIconButton
            as={Link}
            to={`/internos/${internal.id}`}
            icon={<FaEye />}
            tooltip="Visualizar"
          />

          <VisibleAccess
            compareField="unit"
            compareValues={[internal.unit, temporaryReturnAccessByInternal?.[internal.id]?.originUnitId]}
          >
            <VisibleAccess compareField="groups" compareValues={["PLANTONISTA", "ADMINISTRATIVO", "DISCIPLINA", "MONITORAMENTO"]}>
              <VisibleAccess compareField="groups" compareValues={["PLANTONISTA", "ADMINISTRATIVO", "DISCIPLINA"]}>
                {canShowFugaAction(internal) && (
                  <ActionIconButton
                    icon={<FaRunning />}
                    tooltip="Fuga na Saída Temporária"
                    onClick={() => handleOpenFugaModal(internal)}
                  />
                )}
              </VisibleAccess>
            </VisibleAccess>
          </VisibleAccess>
        </td>
      </tr>
    );
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container">
        <Titulo
          children={<h2>Internos por Unidade</h2>}
          children2={
            <VisibleAccess compareField="groups" compareValues={["PLANTONISTA", "ADMINISTRATIVO", "DISCIPLINA", "MONITORAMENTO"]}>
              <div>
                {/* Botão "Cadastrar interno" (RegisterInternals) desativado — substituído pela Entrada Unificada. */}
                {/* <button className="btnAdcionar" onClick={toggleRegisterInternal} disabled={isRegisterLocked}>
                  {showRegisterInternal ? (
                    <>
                      <img src={X} alt="icone" className="icon" /> Cancelar cadastro
                    </>
                  ) : (
                    <>
                      <img src={PlusCircle} alt="icone" className="icon" /> Cadastrar interno
                    </>
                  )}
                </button> */}
                <button className="btnAdcionar" onClick={toggleUnifiedEntry} disabled={isUnifiedEntryLocked}>
                  {showUnifiedEntry ? (
                    <>
                      <img src={X} alt="icone" className="icon" /> Cancelar entrada
                    </>
                  ) : (
                    <>
                      <img src={PlusCircle} alt="icone" className="icon" /> Nova Entrada
                    </>
                  )}
                </button>
              </div>
            </VisibleAccess>
          }
        />

        <InternalsFilterPanel
          statusOptions={statusOptions}
          showUnitFilter={false}
          fixedUnitId={effectiveUnitId}
          onSearch={handleFiltersSearch}
          onClear={handleFiltersClear}
        />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 0 8px' }}>
          <span style={{ fontSize: '13px', color: 'var(--texto-destaque)', fontWeight: 600 }}>
            {unidadeAtiva ? `Internos da unidade: ${unidadeAtiva.name || unidadeAtiva.acronym}` : ''}
          </span>
          {!isLoadingInternals && (
            <span style={{ fontSize: '13px', fontWeight: 700, color: '#b91c1c', background: '#fee2e2', padding: '3px 12px', borderRadius: '12px' }}>
              {totalItems} {totalItems === 1 ? 'Interno' : 'Internos'}
            </span>
          )}
        </div>

        {/* {showRegisterInternal && (
          <div className="content-register">
            <RegisterInternals onSave={handleInternalSave} onLockChange={setIsRegisterLocked} />
          </div>
        )} */}

        {showUnifiedEntry && (
          <div className="content-register">
            <UnifiedEntry onSave={handleUnifiedEntrySave} onLockChange={setIsUnifiedEntryLocked} />
          </div>
        )}

        <div className="content content-table">
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CPF</th>
                <th>Unidade</th>
                <th>Pavilhão</th>
                <th>Cela</th>
                <th>Status</th>
                <th style={{ textAlign: 'center' }}>Ações</th>
              </tr>
            </thead>
            {isLoadingInternals ? (
              <Skeleton type="table" rows={5} cols={6} prefix="internals-unit-list" />
            ) : (
              <tbody>
                {internals.length > 0 ? (
                  internals.map(renderizarLinhaInterno)
                ) : (
                  <tr>
                    <td colSpan="7">Nenhum interno encontrado.</td>
                  </tr>
                )}
              </tbody>
            )}
          </table>

          {!isLoadingInternals && (
            <div className="pagination-options">
              <div>
                <label htmlFor="itemsPerPage">Internos por página:</label>
                <select
                  id="itemsPerPage"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  <option value={10}>10</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={Math.ceil(totalItems / itemsPerPage)}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                activeClassName={'activeNumber'}
                previousClassName={'prev'}
                nextClassName={'next'}
                pageClassName={'page'}
                breakClassName={'break-me'}
              />
            </div>
          )}
        </div>

        {showFugaModal && (
          <Modal
            title="Fuga na Saída Temporária"
            isOpen={showFugaModal}
            closeModal={closeFugaModal}
          >
            <form className="temporary-return-form" onSubmit={handleFugaSubmit}>
              <div className="form-group modal-form">
                <label>Interno</label>
                <input type="text" value={fugaInternal?.name || ''} readOnly />
              </div>

              <div className="form-group modal-form">
                <label>Data da fuga</label>
                <input
                  type="date"
                  value={fugaLeavingDate}
                  onChange={(e) => setFugaLeavingDate(e.target.value)}
                  disabled={isSubmittingFuga}
                  required
                />
              </div>

              <div className="temporary-return-actions">
                <button type="button" className="btn-edit" onClick={closeFugaModal} disabled={isSubmittingFuga}>
                  Cancelar
                </button>
                <button type="submit" className="save-btn" disabled={isSubmittingFuga}>
                  {isSubmittingFuga ? 'Salvando...' : 'Registrar Fuga'}
                </button>
              </div>
            </form>
          </Modal>
        )}

        <ConfirmModal
          isOpen={showFugaConfirmModal}
          closeModal={() => setShowFugaConfirmModal(false)}
          onConfirm={handleFugaConfirm}
          mainMessage="Confirmar registro de fuga?"
          secondaryMessage={`O interno ${fugaInternal?.name || ''} será marcado como Fugitivo. Essa ação não pode ser desfeita.`}
          loading={isSubmittingFuga}
        />
      </div>
    </div>
  );
}

export default InternalsByUnit;
